import { StateCreator } from 'zustand';
import type { EmployeeType } from '../../services/api/models/EmployeeType';

export interface PayrollFilters {
  clinicId: string | null;
  /** ISO date strings (yyyy-mm-dd); both required before fetching. */
  startDate: string | null;
  endDate: string | null;
  /** null = All employee types. */
  employeeType: EmployeeType | null;
  search: string;
}

export interface PayrollSlice {
  payrollFilters: PayrollFilters;
  setPayrollFilters: (filters: Partial<PayrollFilters>) => void;
}

const DEFAULT_PAYROLL_FILTERS: PayrollFilters = {
  clinicId: null,
  startDate: null,
  endDate: null,
  employeeType: null,
  search: '',
};

export const payrollSlice: StateCreator<PayrollSlice> = set => ({
  payrollFilters: DEFAULT_PAYROLL_FILTERS,
  setPayrollFilters: (filters: Partial<PayrollFilters>) =>
    set(state => ({
      payrollFilters: { ...state.payrollFilters, ...filters },
    })),
});
